import { render, staticRenderFns } from "./userLeaves.vue?vue&type=template&id=71f4b114&"
import script from "./userLeaves.vue?vue&type=script&lang=js&"
export * from "./userLeaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports